import React, { useState } from "react";
import {
  Typography,
  Box,
  Toolbar,
  Grid,
  TextField,
  IconButton,
  CircularProgress,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import { borderRadius } from "@mui/system";
import Layout from "./Layout";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "88vh",
    backgroundColor: "#ededed",
  },
  toolbar: {
    backgroundColor: "#ededed",
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0, 2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    color: "black",
  },
  searchContainer: {
    display: "flex",
    marginTop: theme.spacing(2),
    alignItems: "center",
    backgroundColor: "#ededed",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
  },
  searchInput: {
    flexGrow: 1,
    marginRight: theme.spacing(2),
  },
  icon: {
    color: theme.palette.text.secondary,
  },
  // resultsContainer: {
  //   marginTop: theme.spacing(2),
  //   height: "100%",
  //   overflow: "auto",
  // },
  sqlCode: {
    fontFamily: "monospace",
    padding: "10px",
    borderRadius: "5px",
  },
  resultsContainer: {
    marginTop: 20,
  },
}));

const Results = ({
  data,
  searchQuery,
  setSearchQuery,
  handleSearch,
  isLoading,
  selectedDb,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderResults = () => {
    if (data?.result?.rows && data.result.rows.length) {
      if (
        data.result.rows.length === 1 &&
        Object.keys(data.result.rows[0]).length === 1
      ) {
        const [key, value] = Object.entries(data.result.rows[0])[0];
        return (
          <TableContainer component={Paper} className={classes.resultsContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Key</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{key}</TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        );
      } else {
        return (
          <TableContainer
            component={Paper}
            className={classes.resultsContainer}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {Object.keys(data?.result?.rows[0]).map((key) => (
                    <TableCell key={key}>{key}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.result?.rows.map((row, index) => (
                  <TableRow key={index}>
                    {Object.values(row).map((value, index) => (
                      <TableCell key={index}>{value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      }
    } else {
      return <div className={classes.resultsContainer}>No Results Found</div>;
    }
  };
  return (
    <Layout>
      <div className="SubHeaderText">Search Results</div>
      <Accordion
        fullWidth
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        className="AccordionInfo"
      >
        <AccordionSummary>
          <code>{"</> "}Code</code>
          <Button>Show SQL </Button>
        </AccordionSummary>
        <AccordionDetails>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#ededed",
            }}
          >
            {data?.unedited?.split("\n").map((line, index) => (
              <code key={index} className={classes.sqlCode}>
                {line}
              </code>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
      <br />
      <div className="SearchContainer">
      <TextField
          id="ppl-query-input"
          placeholder="Query the Database in Natural Language?"
          variant="outlined"
          fullWidth
          className="SearchInput"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery.length > 0 && (
                  <IconButton onClick={() => setSearchQuery("")}>
                    <ClearIcon />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={() => handleSearch(selectedDb)}
          variant="contained"
          className="SearchBtn"
        >
          <SearchIcon fontSize="large" />
        </Button>
      </div>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : (
        renderResults()
      )}
    </Layout>
  );
};

export default Results;
